import React, { useMemo, memo } from 'react'
import dynamic from 'next/dynamic'
import getCollectionProductData from '@helpers/filters/getCollectionProductData'
import styles from './styles.module.scss'
import { Collection } from 'types/collection'
import { FilterOption } from 'types/filters'

const CollectionProductList = dynamic(() => import('../CollectionProductList'))
const CollectionNoResult = dynamic(() => import('../CollectionNoResult'))

type CollectionWrapperProps = {
  collections: Collection[]
  filterOptions: FilterOption[]
  variantExist: boolean
  onFilterClear: () => void
}

const CollectionWrapper = ({
  collections,
  filterOptions,
  variantExist,
  onFilterClear
}: CollectionWrapperProps) => {
  const { collectionsWithFilteredProducts } = useMemo(
    () =>
      getCollectionProductData({
        collections,
        filterOptions,
        variantExist
      }),
    [collections, filterOptions, variantExist]
  )
  const numberOfCollections = collectionsWithFilteredProducts.length

  if (numberOfCollections === 0) {
    return (
      <section className={styles.collection}>
        <CollectionNoResult onFilterClear={onFilterClear} />
      </section>
    )
  }

  const collectionProducts = collectionsWithFilteredProducts.flatMap(
    ({ items }) => items
  )

  return <CollectionProductList products={collectionProducts} />
}

export default memo(CollectionWrapper)
